import CustomCursor from "@/components/animatedComponents/CustomCursor";
import LightSpots from "@/components/animatedComponents/LightSpots";
import HeroSection from "@/components/HeroSection";
import HorizontalScroll from "@/components/HorizontalScroll";
import WhatWeDo from "@/components/WhatWeDo";
import Gallery from "@/components/Gallery";
import WebServicesBanner from "@/components/WebServicesBanner";
import GarageSlider from "@/components/GarageSlider";
import Navbar from "@/components/Navbar";
import ShrinkOnScroll from "@/components/animatedComponents/ShrinkOnScroll";
import B2bSection from "@/components/B2bSection";
import Numbers from "@/components/animatedComponents/Numbers";

const Index = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f5] relative overflow-x-hidden">
      {/* Custom Cursor */}
      <CustomCursor />

      {/* Light Spots Background */}
      <LightSpots />

      {/* Main Layout */}
      <div className="relative z-10">
        <Navbar />
        <main className="lg:bg-[#0D1821]">
          <div id="smooth-wrapper">
            <div id="smooth-content">
              <ShrinkOnScroll className="bg-[#f5f5f5]">
                <HeroSection />
              </ShrinkOnScroll>

              <WhatWeDo />
              <WebServicesBanner />
              <Numbers />
              <Gallery />
              <HorizontalScroll />
              <B2bSection />
              <GarageSlider />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Index;
